module.exports = __webpack_public_path__ + "static/NunitoSans-SemiBold-b56c7e1dd3d7a5fad61e46f4dd553294.woff2";